import React, { useEffect } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { routes } from "./routesSetup";
import "./App.scss";
import { useSelector } from "react-redux";
import ProtectedRoute from "./pages/SecurityPages/ProtectedRoute";
import UnProtectedRoute from "./pages/SecurityPages/UnProtectedRoute";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { setWindowAction } from "ReduxSaga/actions/GeneralActions";
import BlurPage from "pages/BlurPage";
import 'leaflet/dist/leaflet.css';
import "react-quill/dist/quill.snow.css";

const App: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const generalStates = useSelector((state: any) => state.generalState);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0 });
    }, 1);
    // console.clear()
  }, [navigate]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0 });
    }, 10);
    window.addEventListener("resize", handleResize);
  }, []);

  function handleResize() {
    dispatch(setWindowAction(window.innerWidth));
  }

  return (
    <div
      style={{
        overflow: "hidden",
        position: "relative",
        filter: generalStates.isBlur ? "blur(3px)" : "none",
        transition: "0.2s",
        overflowY:'hidden'
      }}
    >
      {generalStates.isBlur ? <BlurPage /> : <></>}
        <Routes>
          {routes.map((route, key) => {
            return route.protected ? (
              <Route
                key={key}
                path={route.path}
                element={<ProtectedRoute route={route} />}
              />
            ) : (
              <Route
                key={key}
                path={route.path}
                element={<UnProtectedRoute route={route} />}
              />
            );
          })}
        </Routes>
    </div>
  );
};

export default App;
